import * as Yup from 'yup'

const BankAccountFormSchema = () => Yup.object().shape({
  accountHolder: Yup.string().required(),
  mandateApproved: Yup.bool().oneOf([true], 'You must approve the mandate'),
})

export default BankAccountFormSchema
